import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HistoricalResearchArchive from './pages/historical-research-archive';
import CompleteWorksLibrary from './pages/complete-works-library';
import HomepageLiteraryUniverseHub from './pages/homepage-literary-universe-hub';
import BlogDetail from "./pages/author-s-desk-articles-commentary/components/BlogDetail";
import BookDetailSection from "./pages/book-item";
import CoachItem from "./pages/historical-research-archive/components/CoachItem";
import Biography from "./pages/biography";
import LiveStreams from "./pages/LiveStreams/LiveStreams";
import JewelryAstralZefiro from "./pages/jewerly";
import AuthorInterviews from "./pages/interviews";
import CompaniesCoaches from "./pages/historical-research-archive/components/emotional";
import AstrologicServices from "./pages/historical-research-archive/components/astrologic-services";
import Oratory from "./pages/historical-research-archive/components/oratory";
import FaceLecture from "./pages/historical-research-archive/components/face-lecture";
import NoVerbalCom from "./pages/historical-research-archive/components/no-verbal-com";
import AuthorsDeskArticlesCommentary from "./pages/author-s-desk-articles-commentary";
import Photos from "./pages/Photos/Photos";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<HomepageLiteraryUniverseHub />} />
        <Route path="/historical-research-archive" element={<HistoricalResearchArchive />} />
        <Route path="/complete-works-library" element={<CompleteWorksLibrary />} />
        <Route path="/homepage-literary-universe-hub" element={<HomepageLiteraryUniverseHub />} />
        <Route path="/books/:id" element={<BookDetailSection />} />
        <Route path="/coach/:id" element={<CoachItem />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/author-s-desk-articles-commentary" element={<AuthorsDeskArticlesCommentary />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/biography" element={<Biography/>}/>
        <Route path="/lives" element={<LiveStreams/>}/>
        <Route path="/fotos" element={<Photos/>}/>
        <Route path="/jewerly" element={<JewelryAstralZefiro/>}/>
        <Route path="/interviews" element={<AuthorInterviews/>}/>
        <Route path="/companies-coaches" element={<CompaniesCoaches/>}/>
        <Route path="/astrologic-services" element={<AstrologicServices/>}/>
        <Route path="/oratory" element={<Oratory/>}/>
        <Route path="/face-lecture" element={<FaceLecture/>}/>
        <Route path="/no-verbal-com" element={<NoVerbalCom/>}/>
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
